/* Work'N Gear — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile nav toggle ---- */
  var hamburger = document.querySelector('.wng-nav__hamburger');
  var mobileMenu = document.querySelector('.wng-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
    });
  }

  /* ---- Search toggle ---- */
  var searchToggle = document.getElementById('wng-search-toggle');
  var searchPanel  = document.getElementById('wng-nav-search');
  var searchClose  = document.getElementById('wng-search-close');
  var searchInput  = document.getElementById('wng-search-input');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open);
      searchPanel.setAttribute('aria-hidden', !open);
      if (open && searchInput) setTimeout(function() { searchInput.focus(); }, 50);
    });
  }
  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', function () {
      searchPanel.classList.remove('is-open');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
      searchPanel.setAttribute('aria-hidden', 'true');
    });
  }
  /* Close search on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchPanel && searchPanel.classList.contains('is-open')) {
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
    }
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.wng-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = this.closest('.wng-faq__item');
      var isOpen = item.classList.contains('wng-faq__item--open');
      document.querySelectorAll('.wng-faq__item').forEach(function (i) {
        i.classList.remove('wng-faq__item--open');
        i.querySelector('.wng-faq__question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('wng-faq__item--open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---- Quick Add to cart ---- */
  window.wngQuickAdd = function(e, variantId) {
    e.preventDefault();
    var btn = e.currentTarget;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = '✓ Added!';
      wngUpdateCartCount();
      setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 1800);
    })
    .catch(function() { btn.textContent = orig; btn.disabled = false; });
  };

  /* ---- Update cart count in nav ---- */
  function wngUpdateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEl = document.querySelector('.wng-nav__cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            var cartLink = document.querySelector('.wng-nav__cart');
            if (cartLink) {
              var el = document.createElement('span');
              el.className = 'wng-nav__cart-count';
              el.textContent = cart.item_count;
              cartLink.appendChild(el);
            }
          } else {
            countEl.textContent = cart.item_count;
          }
        }
      });
  }

  /* ---- Sticky header shadow on scroll ---- */
  var header = document.getElementById('wng-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('wng-header--scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---- Smooth scroll for anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.getElementById(this.getAttribute('href').slice(1));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
